module.exports = __webpack_public_path__ + "static/img/0002mdm.62b46f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0002mdm.jpg
// module id = lMLw
// module chunks = 0